import { $ as jquery } from 'jquery';

var $ = jquery;

if (typeof window !== 'undefined') {
  window.layui = window.layui || {};
  window.layui.jquery = window.layui.jquery || $;
  window.$ = window.$ || $;
  window.jQuery = window.jQuery || $;
}

var autocomplete = (function () {
  (function ($) {
    function trimText(value) {
      return value == null ? '' : String(value).trim();
    }

    function isFunction(fn) {
      return typeof fn === 'function';
    }

    function escapeHtml(value) {
      return String(value == null ? '' : value)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#39;');
    }

    var reEscape = new RegExp(
      '(\\' + ['/', '.', '*', '+', '?', '|', '(', ')', '[', ']', '{', '}', '\\'].join('|\\') + ')',
      'g',
    );

    function fnFormatResult(value, data, currentValue) {
      var safeValue = escapeHtml(value);
      var query = trimText(currentValue);
      var pattern;
      if (!query) {
        return safeValue;
      }
      pattern = '(' + escapeHtml(query).replace(reEscape, '\\$1') + ')';
      return safeValue.replace(new RegExp(pattern, 'gi'), '<strong>$1</strong>');
    }

    function Autocomplete(el, options) {
      options = options || {};
      this.el = $(el);
      this.el.attr('autocomplete', 'off');
      this.suggestions = [];
      this.data = [];
      this.badQueries = [];
      this.selectedIndex = -1;
      this.currentValue = this.el.val();
      this.hideTimer = 0;
      this.requestTimer = 0;
      this.cachedResponse = [];
      this.ignoreValueChange = false;
      this.serviceUrl = options.serviceUrl;
      this.isLocal = false;
      this.enabled = false;
      this.disabled = false;
      this.pendingQuery = '';
      this.requestSeq = 0;
      this.lastCompletedRequestSeq = 0;
      this.eventNs = '.autocomplete_' + Math.random().toString(36).slice(2, 10);
      this.options = {
        autoSubmit: false,
        minChars: 1,
        maxHeight: 300,
        deferRequestBy: 0,
        width: 0,
        highlight: true,
        params: {},
        fnFormatResult: fnFormatResult,
        delimiter: null,
        zIndex: 9999,
      };
      this.initialize();
      this.setOptions(options);
    }

    $.fn.autocomplete = function (options) {
      var $el = this.eq(0);
      var existing;
      var instance;
      if (!$el.length) {
        return new Autocomplete($('<input />'), options);
      }
      existing = $el.data('layui.autocomplete');
      if (existing && isFunction(existing.destroy)) {
        existing.destroy();
      }
      instance = new Autocomplete($el, options);
      $el.data('layui.autocomplete', instance);
      return instance;
    };

    Autocomplete.prototype = {
      killerFn: null,

      initialize: function () {
        var me = this;
        var uid = Math.floor(Math.random() * 0x100000).toString(16);
        var autocompleteElId = 'Autocomplete_' + uid;

        this.killerFn = function (event) {
          if ($(event.target).closest('.autocomplete').length === 0) {
            me.killSuggestions();
            me.disableKillerFn();
          }
        };

        this.mainContainerId = 'AutocompleteContainer_' + uid;

        $(
          '<div id="' +
            this.mainContainerId +
            '" style="position:absolute;z-index:9999;display:none;">' +
            '<div class="autocomplete-w1">' +
            '<div class="autocomplete" id="' +
            autocompleteElId +
            '" style="display:none;width:300px;"></div>' +
            '</div>' +
            '</div>',
        ).appendTo('body');

        this.container = $('#' + autocompleteElId);

        if (!this.options.width) {
          this.options.width = this.el.outerWidth();
        }

        this.fixPosition();
        this.el.on('keydown' + this.eventNs, function (event) {
          me.onKeyPress(event);
        });
        this.el.on('keyup' + this.eventNs, function (event) {
          me.onKeyUp(event);
        });
        this.el.on('blur' + this.eventNs, function () {
          me.enableKillerFn();
        });
        this.el.on('focus' + this.eventNs, function () {
          me.fixPosition();
        });
        $(window).on('resize' + this.eventNs + ' scroll' + this.eventNs, function () {
          if (me.enabled) {
            me.fixPosition();
          }
        });
      },

      setOptions: function (options) {
        var o = this.options;
        $.extend(true, o, options);
        if (o.lookup) {
          this.isLocal = true;
          if (Array.isArray(o.lookup)) {
            o.lookup = { suggestions: o.lookup, data: [] };
          }
        } else {
          this.isLocal = false;
        }
        if (!o.width) {
          o.width = this.el.outerWidth();
        }
        $('#' + this.mainContainerId).css({ zIndex: o.zIndex });
        this.container.css({ maxHeight: o.maxHeight + 'px', width: o.width });
      },

      clearCache: function () {
        this.cachedResponse = [];
        this.badQueries = [];
      },

      disable: function () {
        this.disabled = true;
        this.hide();
      },

      enable: function () {
        this.disabled = false;
      },

      fixPosition: function () {
        var offset = this.el.offset();
        if (!offset) {
          return;
        }
        $('#' + this.mainContainerId).css({
          top: offset.top + this.el.outerHeight(),
          left: offset.left,
          width: this.options.width || this.el.outerWidth(),
        });
      },

      enableKillerFn: function () {
        $(document).off('click' + this.eventNs, this.killerFn).on('click' + this.eventNs, this.killerFn);
      },

      disableKillerFn: function () {
        $(document).off('click' + this.eventNs, this.killerFn);
      },

      killSuggestions: function () {
        var me = this;
        this.stopKillSuggestions();
        this.hideTimer = window.setTimeout(function () {
          me.hide();
          me.stopKillSuggestions();
        }, 150);
      },

      stopKillSuggestions: function () {
        window.clearTimeout(this.hideTimer);
        this.hideTimer = 0;
      },

      onKeyPress: function (event) {
        if (this.disabled) {
          return;
        }
        switch (event.keyCode) {
          case 27:
            this.el.val(this.currentValue);
            this.hide();
            break;
          case 9:
          case 13:
            if (this.selectedIndex === -1) {
              this.hide();
              return;
            }
            this.select(this.selectedIndex);
            if (event.keyCode === 9) {
              return;
            }
            break;
          case 38:
            this.moveUp();
            break;
          case 40:
            this.moveDown();
            break;
          default:
            return;
        }
        event.stopImmediatePropagation();
        event.preventDefault();
      },

      onKeyUp: function (event) {
        if (this.disabled) {
          return;
        }
        switch (event.keyCode) {
          case 13:
          case 27:
          case 38:
          case 40:
            return;
          default:
        }

        window.clearTimeout(this.requestTimer);
        if (this.currentValue !== this.el.val()) {
          if (this.options.deferRequestBy > 0) {
            var me = this;
            this.requestTimer = window.setTimeout(function () {
              me.onValueChange();
            }, this.options.deferRequestBy);
          } else {
            this.onValueChange();
          }
        }
      },

      onValueChange: function () {
        var query;
        window.clearTimeout(this.requestTimer);
        this.requestTimer = 0;
        this.currentValue = this.el.val();
        query = this.getQuery(this.currentValue);
        this.selectedIndex = -1;

        if (this.ignoreValueChange) {
          this.ignoreValueChange = false;
          return;
        }

        if (query === '' || query.length < this.options.minChars) {
          this.hide();
        } else {
          this.getSuggestions(query);
        }
      },

      getQuery: function (value) {
        var delimiter = this.options.delimiter;
        var parts;
        if (!delimiter) {
          return trimText(value);
        }
        parts = value.split(delimiter);
        return trimText(parts[parts.length - 1]);
      },

      getSuggestionsLocal: function (query) {
        var source = this.options.lookup;
        var len = source.suggestions.length;
        var result = { suggestions: [], data: [] };
        var lowerQuery = query.toLowerCase();
        var i;
        var value;

        for (i = 0; i < len; i++) {
          value = source.suggestions[i];
          if (String(value).toLowerCase().indexOf(lowerQuery) === 0) {
            result.suggestions.push(value);
            result.data.push(source.data[i]);
          }
        }
        return result;
      },

      getSuggestions: function (query) {
        var cached = this.isLocal ? this.getSuggestionsLocal(query) : this.cachedResponse[query];
        var params;
        var requestId;
        var me = this;

        this.pendingQuery = query;

        if (cached && Array.isArray(cached.suggestions)) {
          this.suggestions = cached.suggestions;
          this.data = cached.data || [];
          this.suggest();
          return;
        }

        if (this.isLocal || this.isBadQuery(query)) {
          this.hide();
          return;
        }

        requestId = ++this.requestSeq;
        params = $.extend({}, this.options.params, { query: query });

        $.get(this.serviceUrl, params, function (text) {
          me.processResponse(text, query, requestId);
        }, 'text');
      },

      isBadQuery: function (query) {
        var i = this.badQueries.length;
        while (i--) {
          if (query.indexOf(this.badQueries[i]) === 0) {
            return true;
          }
        }
        return false;
      },

      hide: function () {
        this.enabled = false;
        this.selectedIndex = -1;
        $('#' + this.mainContainerId).hide();
        this.container.hide();
      },

      renderSuggestionItem: function (index, suggestion, query) {
        var me = this;
        var item = $('<div>')
          .attr('title', trimText(suggestion))
          .html(this.options.fnFormatResult(suggestion, this.data[index], query));

        if (this.selectedIndex === index) {
          item.addClass('selected');
        }

        item.on('mouseenter' + this.eventNs, function () {
          me.activate(index);
        });
        item.on('mousedown' + this.eventNs, function (event) {
          event.preventDefault();
        });
        item.on('click' + this.eventNs, function () {
          me.select(index);
        });
        return item;
      },

      suggest: function () {
        var len;
        var query;
        var i;

        if (this.suggestions.length === 0) {
          this.hide();
          return;
        }

        len = this.suggestions.length;
        query = this.getQuery(this.currentValue);
        this.fixPosition();
        this.container.hide().empty();

        for (i = 0; i < len; i++) {
          this.container.append(this.renderSuggestionItem(i, this.suggestions[i], query));
        }

        this.enabled = true;
        $('#' + this.mainContainerId).show();
        this.container.show();
      },

      processResponse: function (text, query, requestId) {
        var response;

        try {
          response = JSON.parse(text);
        } catch (err) {
          return;
        }

        if (requestId < this.lastCompletedRequestSeq) {
          return;
        }
        this.lastCompletedRequestSeq = requestId;

        if (!Array.isArray(response.suggestions)) {
          response.suggestions = [];
        }
        if (!Array.isArray(response.data)) {
          response.data = [];
        }
        if (!response.query) {
          response.query = query;
        }

        if (!this.options.noCache) {
          this.cachedResponse[response.query] = response;
          if (response.suggestions.length === 0) {
            this.badQueries.push(response.query);
          }
        }

        if (response.query === this.getQuery(this.el.val()) && response.query === this.pendingQuery) {
          this.currentValue = this.el.val();
          this.suggestions = response.suggestions;
          this.data = response.data;
          this.suggest();
        }
      },

      activate: function (index) {
        var divs = this.container.children();
        var activeItem;
        if (this.selectedIndex !== -1 && divs.length > this.selectedIndex) {
          $(divs.get(this.selectedIndex)).removeClass('selected');
        }
        this.selectedIndex = index;
        if (this.selectedIndex !== -1 && divs.length > this.selectedIndex) {
          activeItem = divs.get(this.selectedIndex);
          $(activeItem).addClass('selected');
        }
        return activeItem;
      },

      select: function (index) {
        var selectedValue = this.suggestions[index];
        var form;
        if (selectedValue) {
          this.el.val(selectedValue);
          if (this.options.autoSubmit) {
            form = this.el.parents('form');
            if (form.length > 0) {
              form.get(0).submit();
            }
          }
          this.ignoreValueChange = true;
          this.hide();
          this.onSelect(index);
        }
      },

      moveUp: function () {
        if (this.selectedIndex === -1) {
          return;
        }
        if (this.selectedIndex === 0) {
          this.container.children().get(0).className = '';
          this.selectedIndex = -1;
          this.el.val(this.currentValue);
          return;
        }
        this.adjustScroll(this.selectedIndex - 1);
      },

      moveDown: function () {
        if (this.selectedIndex === this.suggestions.length - 1) {
          return;
        }
        this.adjustScroll(this.selectedIndex + 1);
      },

      adjustScroll: function (index) {
        var activeItem = this.activate(index);
        var offsetTop = activeItem.offsetTop;
        var upperBound = this.container.scrollTop();
        var lowerBound = upperBound + this.options.maxHeight - 25;
        if (offsetTop < upperBound) {
          this.container.scrollTop(offsetTop);
        } else if (offsetTop > lowerBound) {
          this.container.scrollTop(offsetTop - this.options.maxHeight + 25);
        }
        this.el.val(this.getValue(this.suggestions[index]));
      },

      onSelect: function (index) {
        var fn = this.options.onSelect;
        var suggestion = this.suggestions[index];
        var data = this.data[index];
        this.el.val(this.getValue(suggestion));
        if (isFunction(fn)) {
          fn(suggestion, data, this.el);
        }
      },

      getValue: function (value) {
        var delimiter = this.options.delimiter;
        var currentValue;
        var parts;
        if (!delimiter) {
          return value;
        }
        currentValue = this.currentValue;
        parts = currentValue.split(delimiter);
        if (parts.length === 1) {
          return value;
        }
        return currentValue.substr(0, currentValue.length - parts[parts.length - 1].length) + value;
      },

      destroy: function () {
        this.disableKillerFn();
        this.stopKillSuggestions();
        window.clearTimeout(this.requestTimer);
        this.requestTimer = 0;
        this.el.off(this.eventNs).removeData('layui.autocomplete');
        $(window).off(this.eventNs);
        this.container.off(this.eventNs);
        $('#' + this.mainContainerId).remove();
      },
    };
  })($);
  return $.fn.autocomplete;
})();

if (typeof window !== 'undefined') {
  window.layui = window.layui || {};
  window.layui.autocomplete = autocomplete;
  if (window.jQuery) {
    window.jQuery.fn.autocomplete = $.fn.autocomplete;
  }
}

export { autocomplete };
